import { useContext } from 'react';
import useCURD_Queries from '../queryGenerals/useCURD_Queries';
import { GlobalContext } from '../../../App';
import { v4 as uuidv4 } from 'uuid';
import { useAddData, useGetDataByName, useUpdateData, updateOrAddItem } from '../../dataLocal/indexedDBHooks';

const getUserIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('שגיאה בקבלת כתובת IP:', error);
    return null;
  }
};

const useCemeteryQueries = () => {
  const { userId, db } = useContext(GlobalContext);
  const { AllDataEntities, addOrUpdateDataEntity2, removeEntity } = useCURD_Queries();

  const addData = useAddData(db, 'myStore');
  const updateData = useUpdateData(db, 'myStore');
  const getDataByName = useGetDataByName(db, 'myStore');

  const AllDataCemeteries = async (localCemeteries) => {
    try {
      let query = `api/cemeteries/getCemeteries`;
      let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`;
      let nameEntity = 'dataCemeteries';
      
      // 1. בקשת נתונים מהשרת
      const resData = await AllDataEntities(url, localCemeteries); // המתנה לתוצאה מהשרת
  
      // 2. בדיקה אם מסד הנתונים המקומי (db) זמין
      if (db) {
        // 3. שליפת נתונים קיימים מה-IndexedDB לפי שם הישות (nameEntity)
        getDataByName(nameEntity)
          .then((existingData) => {
            // 4. בדיקה אם יש נתונים קיימים תחת מפתח זה ב-IndexedDB
            if (existingData.length > 0) {
              // אם הנתונים קיימים, מבצעים עדכון
              updateData({ id: 1, name: nameEntity, value: resData?.resData || [] })
                .then(() => getDataByName(nameEntity)) // שליפה נוספת לאימות העדכון
                .then((data) => {
                  // כאן ניתן לראות את הנתונים המעודכנים
                  // console.log('Updated Data:', data);
                })
                .catch((error) => console.error('Error updating data:', error)); // טיפול בשגיאה בעת העדכון
            } else {
              // אם הנתונים לא קיימים, מוסיפים אותם
              addData({ id: 1, name: nameEntity, value: resData?.resData || [] })
                .then(() => getDataByName(nameEntity)) // שליפה נוספת לאימות ההוספה
                .then((data) => {
                  // כאן ניתן לראות את הנתונים שנוספו
                  // console.log('Added Data:', data);
                })
                .catch((error) => console.error('Error adding data:', error)); // טיפול בשגיאה בעת ההוספה
            }
          })
          .catch((error) => console.error('Error getting data by name:', error)); // טיפול בשגיאה בשליפה הראשונה מ-IndexedDB
      }
    } catch (error) {
      console.error('שגיאה בטעינת נתונים: ', error); // טיפול בשגיאה בעת הבקשה לשרת
    }
  };
  
  const addOrUpdateDataCemetery = async (data, unicId) => {
    let create = `api/cemeteries/addCemetery`;
    let update = `api/cemeteries/updateCemetery`;
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${data?.unicId ? update : create}`;

    let ip = ''
    // דוגמה לשימוש בפונקציה
    await getUserIP().then(myIp => {
      ip = myIp
    });

    // נתונים מינימליים לשליחה לשרת
    const payload = {
      userId,
      recordId: data?.unicId,
      ipAddress: ip,
      tableName: 'cemeteries',
      actionType: (data?.unicId) ? 'UPDATE' : 'INSERT',
      oldValue: null,
      newValue: data,
    };

    if (!data?.unicId) {
      data = {
        ...data,
        unicId: unicId
      }
    }

    try {
      let res = await addOrUpdateDataEntity2(data, payload, url); // שליחת הנתונים לשרת
      if (res === 200) {
        await updateOrAddItem(db, 'myStore', data, 'dataCemeteries', 1);
        console.log('עדכון נתונים הצליח.');
        return res;
      } else {
        return false;
      }
    } catch (error) {
      console.error('שגיאה בתהליך העדכון/הוספה:', error);
      return false;
    }
  };

  const removeCemetery = (id) => {
    let query = `api/cemeteries/removeCemetery`;
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`;
    removeEntity(id, url);
  };

  return {
    AllDataCemeteries,
    addOrUpdateDataCemetery,
    removeCemetery
  };
};

export default useCemeteryQueries;
